import styled from 'styled-components';

import { ACQ, COLORS, ANIM } from '../../theme/tokens';

export const Root = styled.button<{ $on: boolean }>`
  display: inline-flex;
  align-items: center;
  width: 48px;
  height: 24px;
  padding: 2px;
  border: none;
  border-radius: 99px;
  cursor: pointer;
  background: ${(p) => (p.$on ? ACQ.orange : COLORS.toggleTrackOff)};
  transition: background ${ANIM.INTERACT_MS}ms ease;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const Knob = styled.span<{ $on: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 99px;
  background: ${COLORS.onAccent};
  /* 48 width − 2×2 padding − 20 knob = 24px of travel. */
  transform: translateX(${(p) => (p.$on ? '24px' : '0')});
  transition: transform ${ANIM.INTERACT_MS}ms ease;
`;
